module.exports = __webpack_public_path__ + "static/media/RU.49fcf0f4.png";